module.exports = __webpack_public_path__ + "static/media/New_York_Image_-_rounded_corners.41d49ab9.png";